export const getApiUrl = () => {
  // 1. Intentar obtener de variables de entorno (inyectadas en build time)
  let url = process.env.REACT_APP_API_URL || import.meta.env?.VITE_API_URL;
  
  // 2. Si es producción y no hay URL, o es una URL relativa, usar /api del host actual
  if (process.env.NODE_ENV === 'production' && (!url || url.startsWith('/'))) {
    return '/api';
  }

  // 3. Fallback a localhost para desarrollo
  url = url || 'http://localhost:5063/api';
  
  return url.replace(/\/$/, '');
};
